<template>
    <div>
        <div class="u-mt5 u-mb3 c-heading__info">
            <div class="u-pr1">Time Period:</div>
            <el-select v-model="timePeriod" @change="loadPage()">
                <el-option v-for="period in timePeriodList" :selected="timePeriod==period.name" :value="period.name" :key="period.id">{{period.name}}</el-option>
            </el-select>
        </div>
        <div class="container">    
            <div class="u-m5 small">
                <pie-chart v-if="pieLoaded" :chartdata="pieData" :options="pieOptions"></pie-chart>
                <div class="u-ml4 u-mt4 c-heading__info">
                    <div class="u-pr1">Available Graphs:</div>
                    <el-select v-model="pieChartType" @change="loadPieChart()">
                        <el-option v-for="chart in pieChartList" :selected="pieChartType==chart.name" :value="chart.name" :key="chart.id">{{chart.name}}</el-option>
                    </el-select>
                </div>
            </div>
            <div class="u-m5 small">
                <bar-chart v-if="barLoaded" :chartdata="barData" :options="barOptions"></bar-chart>
                <div class="u-ml4 u-mt4 c-heading__info">
                    <div class="u-pr1">Available Graphs:</div>
                    <el-select v-model="barChartType" @change="loadBarChart()">
                        <el-option v-for="chart in barChartList" :selected="barChartType==chart.name" :value="chart.name" :key="chart.id">{{chart.name}}</el-option>
                    </el-select>
                </div>  
                <div class="center">
                  <el-button v-if="showBarDetailButton" type="primary" icon="el-icon-search" size="small" round @click="showBarDetail()">Details</el-button>
                </div>
            </div>  
            <div class="u-m5 small">
                <line-chart v-if="lineLoaded" :chartdata="lineData" :options="lineOptions"></line-chart>
            </div>
        </div>
        <el-dialog
          title="Details"
          :visible.sync="showBarDetailValues"
          :close-on-click-modal=false
          :close-on-press-escape=false>
          <div v-html="rawBarDetail()"></div>
          <div class="u-mt5 center">
            <el-button type="primary" @click="showBarDetailValues = false">Close</el-button>
          </div>
        </el-dialog>
    </div>
</template>

<script>
  import BarChart from '@/modules/charts/barchart.component.vue'
  import PieChart from '@/modules/charts/piechart.component.vue'
  import LineChart from '@/modules/charts/linechart.component.vue'
  import axios from 'axios'
  import _ from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      BarChart,
      PieChart,
      LineChart
    },
    data: () => ({
      showBarDetailValues: false,
      barChartList: [
        {id: 'users_by_month', name: 'User Enrollment By Month'},
        {id: 'emails_by_month', name: 'Emails Delivered By Month'},
        {id: 'messages_by_month', name: 'Messages Sent By Month'}],
      barLoaded: false,
      barData: null,
      barRawData: null,
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          fontSize: 18
        },
        scales: {yAxes: [{ticks: {min: 0, precision: 0}}]}
      },
      barChartType: 'User Enrollment By Month',
      pieLoaded: false,
      pieData: null,
      pieOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 0,
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: true,
          fontSize: 18
        }
      },
      pieChartType: 'Application Activity',
      pieChartList: [
        {id: 'actions', name: 'Application Activity'},
        {id: 'versions', name: 'Application Versions'},
        {id: 'browsers', name: 'Browser Types'},
        {id: 'languages', name: 'User Languages'}],
      lineLoaded: false,
      lineData: null,
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: true,
          fontSize: 18
        },
        scales: {yAxes: [{ticks: {min: 0, precision: 0}}]}
      },
      timePeriod: 'All available data',
      timePeriodList: [{id: '-1', name: 'All available data'}, {id: '6', name: '6 Months'}, {id: '3', name: '3 Months'}, {id: '1', name: '1 Month'}]
    }),
    async mounted () {
      if (this.$parent.eDeliveryEnabled()) {
        this.barChartList.push({id: 'paperless_by_month', name: 'Paperless Enrollment By Month'})
        this.pieChartList.push({id: 'document_delivery', name: 'Document Delivery Type'})
      }
      if (this.isSuperuser) {
        this.barChartList.push({id: 'email_failures', name: 'Emails Failures Past 7 Days'})
      }
      this.loadPage()
    },
    computed: {
      ...mapGetters('shared', ['isSuperuser']),
      selectedBarChart: {
        get: function () {
          let chart = _.find(this.barChartList, chart => {
            return chart.name === this.barChartType
          })
          return chart.id
        },
        set: function (newValue) {
          this.barChartType = newValue
        }
      },
      selectedPieChart: {
        get: function () {
          let chart = _.find(this.pieChartList, chart => {
            return chart.name === this.pieChartType
          })
          return chart.id
        },
        set: function (newValue) {
          this.pieChartType = newValue
        }
      },
      selectedTimePeriod: {
        get: function () {
          let period = _.find(this.timePeriodList, timePeriod => {
            return timePeriod.name === this.timePeriod
          })
          return period.id
        },
        set: function (newValue) {
          this.timePeriod = newValue
        }
      },
      showBarDetailButton: {
        get: function () {
          if (!this.barRawData) return false
          return this.$parent.detailsAvailable()
        }
      }
    },
    methods: {
      loadPage () {
        this.loadPieChart()
        this.loadBarChart()
        this.loadLineChart()
      },
      loadBarChart () {
        this.barLoaded = false
        this.barOptions.title.text = this.barChartType
        let params = {timePeriod: this.selectedTimePeriod}

        axios.post(this.getURL(this.selectedBarChart), params)
          .then((ret) => {
            this.barData = ret.data.data[this.selectedBarChart].chart_data
            this.barRawData = ret.data.data[this.selectedBarChart].raw_data
          })
          .finally(() => {
            this.barLoaded = true
          })
      },
      loadPieChart () {
        this.pieLoaded = false
        this.pieOptions.title.text = this.pieChartType
        let params = {timePeriod: this.selectedTimePeriod}

        axios.post(this.getURL(this.selectedPieChart), params)
          .then((ret) => {
            this.pieData = ret.data.data[this.selectedPieChart].chart_data
          })
          .finally(() => {
            this.pieLoaded = true
          })
      },
      loadLineChart () {
        this.lineOptions.title.text = 'User Enrollment Totals'
        this.lineLoaded = false
        let params = {timePeriod: this.selectedTimePeriod}
        let chartType = 'users_total'

        axios.post(this.getURL(chartType), params)
          .then((ret) => {
            this.lineData = ret.data.data[chartType].chart_data
          })
          .finally(() => {
            this.lineLoaded = true
          })
      },
      getURL (chartType) {
        return this.$parent.getURL(chartType)
      },
      showBarDetail () {
        this.showBarDetailValues = true
      },
      createDetailEntry (key, value) {
        return '<td style="padding-right: 30px;"><span class="bar-detail-key">' + key + '</span><span>: ' + value + '</span></td>'
      },
      createDetailHelpEntry (value) {
        return '<td><i title="' + value + '" class="el-input__icon el-icon-search bar-detail-help"></i></td>'
      },
      rawBarDetail () {
        let component = this
        let detail = ''
        if (this.barRawData) {
          detail += '<table style="margin: auto;">'
          component.barRawData.forEach(function (item) {
            detail += '<tr>'
            for (const key in item) {
              if (!item.hasOwnProperty(key)) {
                continue
              }
              if (key !== 'help') {
                detail += component.createDetailEntry(key, item[key])
              } else {
                detail += component.createDetailHelpEntry(item[key])
              }
            }
            detail += '</tr>'
          })
          detail += '</table>'
        }
        return detail
      }
    }
  }
</script>

<style scoped>
  .small {
    max-width: 400px;
    float: left;
  }
  .container {
    width: 100%;
    overflow: auto;
  }

  .el-select {
    width: 62%
  }

  .c-heading__info {
    max-width: 400px;
    display: flex;
    align-items: center;
    margin: auto;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

</style>

<style>

  .bar-detail-key {
    font-weight: bold;
    text-transform: capitalize;
  }

  .bar-detail-help {
    font-weight: bold;
    line-height: normal;
    color: black;
  }

  .bar-detail-help:hover {
    color: red;
  }

</style>

